import { render, staticRenderFns } from "./BeneficiariosListado.vue?vue&type=template&id=e60100a8&scoped=true&"
import script from "./BeneficiariosListado.vue?vue&type=script&lang=js&"
export * from "./BeneficiariosListado.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiariosListado.vue?vue&type=style&index=0&id=e60100a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60100a8",
  null
  
)

export default component.exports